import './StaticCardComponent.scss'
import React from "react";

interface StaticCardProps {
    icon: React.ReactNode
    title: string
    text: string
    gradient?: boolean
    secondaryGradient?: boolean
}

export const StaticCardComponent: React.FC<StaticCardProps> = ({icon, title, text, gradient, secondaryGradient}: StaticCardProps) => {

    const addBackground = () => {
        if (gradient) {
            return 'card-icon-background-gradient'
        }
        if (secondaryGradient) {
            return 'card-icon-background-gradient-secondary'
        }
        return 'card-icon-background'
    }

    return (
        <div className={`static-card-container`}>
            <div className={`static-card-icon ${addBackground()} flex-center`}>{icon}</div>
            <div className={`flex-start`}>
                <div className={`font-md-plus primary-color`}>{title}</div>
                <div className={`font-md font-400 primary-color`}>{text}</div>
            </div>
        </div>
    )
}